import {
  httpApps,
  httpAdminCompanyLocation,
  httpDealer,
} from "../helper/http-common";

class SelectYourDiamondService {
  GetSimilarDiamondsByPage(inputData, pageName) {
    if (pageName == "Mined") {
      return httpApps.post("DiamondLinkForML/LoadDiamonds", inputData);
    } else if (pageName == "Lab") {
      return httpApps.post("DiamondLinkForML/LabGrownDiamonds", inputData);
    } else {
      return httpApps.post(
        "DiamondLinkForML/GetDiamondLInkFancyDiamonds",
        inputData
      );
    }
  }

  GetDiamondLInkFancyDiamonds(inputData) {
    return httpApps.post(
      "DiamondLinkForML/GetDiamondLInkFancyDiamonds",
      inputData
    );
  }

  GetDiamondLInkMinedDiamonds(inputData) {
    return httpApps.post("DiamondLinkForML/LoadDiamonds", inputData);
  }
  LabGrownDiamonds(inputData) {
    return httpApps.post("DiamondLinkForML/LabGrownDiamonds", inputData);
  }
  LoadCompareDiamondsList(inputData) {
    return httpApps.post("DiamondLinkForML/LoadCompareDiamondsList", inputData);
  }
  GetDiamondLinkFiltersDropHint(inputData) {
    return httpApps.post(
      "DiamondLinkForML/GetDiamondLinkFiltersDropHint",
      inputData
    );
  }
  GetDiamondLinkFiltersRequestMoreInfo(inputData) {
    return httpApps.post(
      "DiamondLinkForML/GetDiamondLinkFiltersRequestMoreInfo",
      inputData
    );
  }
  GetDiamondLinkFiltersEmailToFriend(inputData) {
    return httpApps.post(
      "DiamondLinkForML/GetDiamondLinkFiltersEmailToFriend",
      inputData
    );
  }
  GetDiamondLinkFiltersScheduleviewing(inputData) {
    return httpApps.post(
      "DiamondLinkForML/GetDiamondLinkFiltersScheduleviewing",
      inputData
    );
  }
  GetnNavigationList(inputData) {
    return httpApps.post("DiamondLinkforML/GetnNavigationList", inputData);
  }
  GetDiamondLinkFiltersViewStateData(inputData) {
    return httpApps.post(
      "DiamondLinkForML/GetDiamondLinkFiltersViewStateData",
      inputData
    );
  }

  GetDiamondLinkFiltersRequestCertificate(inputData) {
    return httpApps.post(
      "DiamondLinkforML/GetDiamondLinkFiltersRequestCertificate",
      inputData
    );
  }
  LabFilter(inputData) {
    return httpApps.post("DiamondLinkforML/LabFilter", inputData);
  }
  GetDiamondLInkFancyDiamondsFiltersData(inputData) {
    return httpApps.post(
      "DiamondLinkforML/GetDiamondLInkFancyDiamondsFiltersData",
      inputData
    );
  }
  GetDiamondLinkFiltersRequest(inputData) {
    return httpApps.post(
      "DiamondLinkforML/GetDiamondLinkFiltersRequest",
      inputData
    );
  }
  GetDealerInformation(inputData) {
    return httpApps.post("DiamondLinkforML/GetDealerInformation", inputData);
  }
  GetDealerLocationData(inputData) {
    return httpApps.post("DiamondLinkforML/GetDealerLocationData", inputData);
  }
  GetDealerSocialLinksData(inputData) {
    return httpApps.post(
      "DiamondLinkforML/GetDealerSocialLinksData",
      inputData
    );
  }
  GetOptionsDetails(inputData) {
    return httpApps.post("DiamondLinkforML/GetOptionsDetails", inputData);
  }
  GetLocationDetails(inputData) {
    return httpAdminCompanyLocation.post(
      "/Profile/LocationLoadDetailsForML",
      inputData
    );
  }
  ProductTracking(inputData) {
    return httpApps.post("DiamondLinkforML/ProductTracking", inputData);
  }
  DiamondTracking(inputData) {
    return httpApps.post("DiamondLinkforML/DiamondTracking", inputData);
  }
  GetMenuList(inputData) {
    return httpAdminCompanyLocation.post("/Tools/GetMenuListForML", inputData);
  }
  CompanyWhileLabel() {
    return httpDealer.get("/Dashboard/CompanyWhileLabelForML");
  }
  GetLanguage(inputData) {
    return httpAdminCompanyLocation.post(
      "/SelectLenguage/SelectlanguageForDelarForML",
      inputData
    );
  }
}

export default new SelectYourDiamondService();
